import { userLoggingUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/userAgentLogUtilities';
import { useEffect } from 'react';
import config from 'theme/config';

const useScreenHeight = () => {
  useEffect(() => {
    if (!config.settings.useFullscreenAndroid) return;

    const platform = userLoggingUtilities.getUserDeviceLog();

    if (platform.os !== 'Android') return;

    const screenHeight = window.screen.height;
    const root = document.getElementById('game-app');

    if (root) root.style.minHeight = `${screenHeight}px`;
  }, []);
};

export default useScreenHeight;
